import React from "react";
import { Link } from "react-router-dom";
import banner from "../../images/banner.png";

const Banner = () => {
  return (
    <div
      className="bg-cover bg-no-repeat bg-center py-36"
      style={{
        backgroundImage: `url(${banner})`,
      }}
    >
      <div className="container">
        <h1 className="text-6xl capitalize text-gray-800 font-medium mb-4">
          Hani me mençuri, buzëqeshni bukur
        </h1>
        <p className="w-50">
          Relaksohuni, kjo do të jetë shumë e lehtë. Mënyra e zgjuar për të gjetur një dentist.{" "}{" "}
          <br />
          Gjeni një dentist të shkëlqyer sot. Seriozisht, është koha.
        </p>
        <div className="mt-12">
          <Link
            to="/appointment"
            className="bg-primary border border-primary text-white px-3 py-2 font-medium rounded hover:bg-transparent hover:text-primary transition"
          >
            Caktoni një takim
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Banner;
